import React, { useState, useEffect } from "react";
import Main from "../components/layout/Main";
import closeIconDark from "../assets/images/closeIconDark.png";
import editIcon from "../assets/images/editIcon.png";
import carbonFilter from "../assets/images/carbonFilter.png";
import plusTheme1 from "../assets/images/plusTheme1.png";
import gameImg from "../assets/images/gameImg.png";
import unfinishedRoundIcon from "../assets/images/unfinishedRoundIcon.png";
import { useNavigate } from "react-router-dom";
import Form from 'react-bootstrap/Form';
import logoVerticaleTheme from "../assets/images/logoVerticaleTheme.png";
import Modal from 'react-bootstrap/Modal';
import searchIcon from "../assets/images/searchIcon.png";
import tabIcon1 from "../assets/images/tabIcon1.png";
import scoreCardModalImg from "../assets/images/scoreCardModalImg.png";
import golfIcon from "../assets/images/golfIcon.png";
import noteIcon from "../assets/images/noteIcon.png";
import useRequest from "../../src/hooks/useRequest"
import { Severty, ShowToast } from "../helper/toast";
import useGeolocation from './useGeolocation';

function Play() {
  const [TeeData, setTeeData] = useState([])
  const [searchQuery, setSearchQuery] = useState('');
  const [courseDetails, setCourseDetails] = useState({
    date: "", 
    course: "",
    courseId: "",
    courseTee: "",
    teeName: "", 
    courseName: "", 
    holes: "",
    gameFormat: "Stroke Play", // NEW: Game format field
  });
  const [formEndData, setFormEndData] = useState({
    posts_privacy: true,
  });

  // Add method to toggle privacy
  const togglePrivacyEnd = () => {
    setFormEndData(prevData => ({
      ...prevData,
      posts_privacy: !prevData.posts_privacy
    }));
    console.log("formEndData", formEndData.posts_privacy)
  };

  const handlechange = (event) => {
    const { name, value } = event.target;
    setCourseDetails({
      ...courseDetails,
      [name]: value,
    });
    if (name === 'course') {
      const selectedCourse = courseListData.find(course => course.courseId === value);
      setCourseDetails(prevState => ({
        ...prevState,
        courseName: selectedCourse?.name || "",
      }));
    } else if (name === 'courseTee') {
      const selectedTee = TeeData.find(tee => tee._id === value);
      setCourseDetails(prevState => ({
        ...prevState,
        teeName: selectedTee?.name || "",
      }));
    }
  };

  // NEW: Game format descriptions
  const getGameFormatDescription = (format) => {
    switch (format) {
      case "Stroke Play":
        return "Traditional stroke counting - lowest total score wins";
      case "Skins":
        return "Win individual holes - lowest score on each hole wins a 'skin'";
      case "Stableford":
        return "Points-based scoring - earn points based on score relative to par";
      case "Match Play":
        return "Head-to-head competition - win individual holes";
      default:
        return "";
    }
  };

  // NEW: Get format-specific rules
  const getFormatRules = (format) => {
    switch (format) {
      case "Skins":
        return [
          "Lowest score on each hole wins the skin",
          "Tied holes carry over to the next hole", 
          "Winner takes all carried-over skins"
        ];
      case "Stableford":
        return [
          "Eagle or better: 4 points",
          "Birdie: 3 points", 
          "Par: 2 points",
          "Bogey: 1 point",
          "Double bogey+: 0 points"
        ];
      case "Match Play":
        return [
          "Win individual holes head-to-head",
          "Best overall hole record wins",
          "Halved holes don't count toward either player"
        ];
      default:
        return [];
    }
  };

  const [filteredCourses, setFilteredCourses] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);

  const { request } = useRequest();
  const [selectedFriends, setSelectedFriends] = useState([]);
  const [friendList, setFriendList] = useState([]);
  const [profile, setProfile] = useState({});
  const [courseListData, setCourseListData] = useState([])
  const [allGame, setAllGame] = useState([])
  const [allLeaderGame, setAllLeaderGame] = useState([])
  const [addplayer, setAddPlayer] = useState()

  const navigate = useNavigate();

  const [clubDetailEditShow, clubDetailEditModal] = useState(false);
  const clubDetailEditModalClose = () => clubDetailEditModal(false);
  const clubDetailEditModalOpen = () => clubDetailEditModal(true);

  const [addPlayerShow, addPlayerModal] = useState(false);
  const addPlayerModalClose = () => addPlayerModal(false);
  const addPlayerModalOpen = (fetchFriendList) => addPlayerModal(true);
  const [searchDataQuery, setDataSearchQuery] = useState('');
  const [filteredFriendList, setFilteredFriendList] = useState([]);
  const { location } = useGeolocation();

  useEffect(() => {
    unfinishedGame()
  }, [])
  
  useEffect(() => {
    let latitude = null;
    let longitude = null;

    const storedLocation = JSON.parse(localStorage.getItem('userLocation'));
    if (storedLocation) {
      latitude = storedLocation.latitude;
      longitude = storedLocation.longitude;
    } else {
      latitude = location.latitude;
      longitude = location.longitude;
    }

    request({
      url: `/common/getNewcourse?search=${encodeURIComponent(searchQuery)}&latitude=${latitude}&longitude=${longitude}`,
      method: "GET",
      onSuccess: (data) => {
        console.log(data);
        setCourseListData(data.data.docs);
      },
      onError: (error) => {
        console.log(error);
      },
    });
    fetchFriendList();
    setUserProfile();
    unfinishedGame();
  }, [searchQuery]);

  const fetchTeeData = (id) => {
    request({
      url: `/common/getCourseTeeData/${id}`,
      method: "GET",
      onSuccess: (data) => {
        console.log("getCourseTeeData", data)
        setTeeData(data.data.data);
      },
      onError: (error) => {
        console.log(error);
      },
    })
  }

  const unfinishedGame = () => {
    request({
      url: `app/game/get-user-game`,
      method: "GET",
      onSuccess: (data) => {
        console.log("get-user-game", data)
        setAllGame(data.data.docs);
      },
      onError: (error) => {
        console.log(error);
      },
    })

    request({
      url: `app/game/get-user-game-on-leaderboard`,
      method: "GET",
      onSuccess: (data) => {
        console.log("get-user-game-on-leaderboard", data)
        setAllLeaderGame(data.data.docs);
      },
      onError: (error) => {
        console.log(error);
      },
    })

  }

  const today = new Date();
  const formattedDate = `${(today.getMonth() + 1).toString().padStart(2, '0')}${today.getDate().toString().padStart(2, '0')}${today.getFullYear()}`;

  const [playOnLeaderBoardShow, playOnLeaderBoardModal] = useState(false);
  const playOnLeaderBoardModalClose = () => playOnLeaderBoardModal(false);
  const playOnLeaderBoardModalOpen = () => playOnLeaderBoardModal(true);

  const [show, scoreCardStepModal] = useState(false);
  const scoreCardStepModalClose = () => scoreCardStepModal(false);
  const scoreCardStepModalOpen = () => {
    scoreCardStepModal(true)
    playOnLeaderBoardModal(false)
  };

  const setUserProfile = () => {
    request({
      url: "app/user/get-profile",
      method: "GET",
      onSuccess: (data) => {
        console.log("Profile data:", data.data.name);
        setProfile(data.data);
      },
      onError: (error) => {
        console.log("Error fetching profile:", error);
      }
    });
  };
  const userId = profile?._id
  const fetchFriendList = () => {
    request({
      url: "/app/friend/user-friend-list",
      method: "GET",
      onSuccess: (data) => {
        console.log("user-friend-list", data);
        setFriendList(data.data.data);
      },
      onError: (error) => {
        console.log(error);
      },
    });
  };

  useEffect(()=>{
      fetchFriendList()
  },[])
  
  useEffect(() => {
    setFilteredFriendList(friendList);
  }, [addPlayerModalClose,addPlayerModalOpen, friendList]);
  
  // Function to handle search
  const handleDataSearch = (e) => {
    const query = e.target.value;
    setDataSearchQuery(query);

    const filteredFriends = friendList.filter(friend =>
      friend.name.toLowerCase().includes(query.toLowerCase())
    );
    setFilteredFriendList(filteredFriends);
  };

  const handleCheckboxChange = (friendId, friendName, profilePic) => {
    const isFriendSelected = selectedFriends.some(friend => friend.id === friendId);
    if (isFriendSelected) {
      const updatedSelectedFriends = selectedFriends.filter(friend => friend.id !== friendId);
      setSelectedFriends(updatedSelectedFriends);
    } else {
      setSelectedFriends([...selectedFriends, { id: friendId, name: friendName, profilePic: profilePic }]);
    }
  };

  const addPlayerData = () => {
    console.log("selectedfriends", selectedFriends);
    setAddPlayer(selectedFriends);
    addPlayerModalClose();
  };

  const handleRemovePlayer = (friendToRemove) => {
    const updatedSelectedFriends = selectedFriends.filter(friend => friend.id !== friendToRemove.id);
    setSelectedFriends(updatedSelectedFriends);
  };

  const handleFormSubmit = (event) => {
    event.preventDefault();
    const formData = {
      date: event?.target?.date?.value,
      course: courseDetails.courseName,
      courseId: courseDetails.course,
      courseTee: courseDetails.teeName,
      courseTeeId: courseDetails.courseTee,
      holes: event?.target?.holes?.value,
      gameFormat: event?.target?.gameFormat?.value || "Stroke Play", // NEW: Game format
    };
    setCourseDetails(formData);
    clubDetailEditModalClose()
    console.log("formEndData", formEndData.posts_privacy)
  };

  const roundStart = (event) => {
    event.preventDefault();
    if (courseDetails && courseDetails.course && courseDetails.holes) {
      const playersIds = selectedFriends?.map(player => player?.id) || [];
      const startRoundData = {
        course: courseDetails.courseId,
        courseTee: courseDetails.courseTeeId ? courseDetails.courseTeeId : null,
        holes: courseDetails.holes,
        score: "Net",
        primaryStat: "",
        players: [...playersIds, userId],
        isFinished: true,
        posts_privacy: formEndData.posts_privacy,
        gameFormat: courseDetails.gameFormat, // NEW: Include game format
      };
      request({
        url: "/app/game/create-game",
        method: "POST",
        data: startRoundData,
        onSuccess: (data) => {
          const gameId = data.data._id;
          navigate(`/score-keeping/${gameId}`, { state: { response: data.data } });
        },
        onError: (error) => {
          console.log(error);
        },
      });
    } else {
      console.log("please all detail fill")
      ShowToast('Please fill all course details.', Severty.ERROR);
    }
  };

  const handleSearchChange = (event) => {
    const query = event.target.value;
    setSearchQuery(query);

    if (query.trim()) {
      const filtered = courseListData.filter(course =>
        course.name.toLowerCase().includes(query.toLowerCase())
      );
      setFilteredCourses(filtered);
      setShowSuggestions(true);
    } else {
      setFilteredCourses([]);
      setShowSuggestions(false);
    }
  };

  const handleSuggestionClick = (course) => {
    setSearchQuery(course.name);
    fetchTeeData(course.courseId);
    setCourseDetails({
      ...courseDetails,
      course: course.courseId,
      courseName: course.name
    });
    setShowSuggestions(false);
  };

  function navigateToScoreKeepingPage(gameId) {
    window.location.href = `/score-keeping/${gameId}`;
  }

  function navigateToScoreLeaderKeepingPage(gameId) {
    window.location.href = `/score-leader-keeping/${gameId}`
  }
  const gameDelete = (id) => {
    console.log("check the data value ")
    request({
      url: `/app/game/game-delete/${id}`,
      method: "Delete",
      onSuccess: (data) => {
        unfinishedGame()
        ShowToast('Game Deleted Successfully.', Severty.SUCCESS);
      },
      onError: (error) => {
        console.log(error);
      },
    });
  };

  // Combine and sort games by type
  const getAllUnfinishedGames = () => {
    const regularGames = allGame?.filter(game => !game.isFinished).map(game => ({ ...game, isLeaderboard: false })) || [];
    const leaderGames = allLeaderGame?.filter(game => !game.isFinished).map(game => ({ ...game, isLeaderboard: true })) || [];
    
    // Combine and sort - you can change sorting logic as needed
    return [...regularGames, ...leaderGames].sort((a, b) => {
      // Sort by creation date or any other criteria
      return new Date(b.createdAt || 0) - new Date(a.createdAt || 0);
    });
  };

  return (
    <>
      <Main>
        <section className="home-wrap playPageOuter  px-lg-4 px-3 pb-lg-4 pb-3 container-fluid">
          <div className="row g-3 ">
            <div className="col-xl-8">
              <div className="customCard rounded-3 bg-white d-flex flex-column flex-nowrap h-100">
                <div className="customCardHeader pb-0">
                  <div className="title pb-3 border-bottom">Round Setup</div>
                </div>
                <div className="customCardBody flex-fill h-100 overflow-auto">
                  <div className="golfClubDetail pb-3 d-flex align-items-center justify-content-between">
                    <div className=" d-flex align-items-center gap-12">
                      <div className="icon">
                        <img src={carbonFilter} />
                      </div>
                      <div className="detail">
                        <div className="name">{courseDetails.courseName || "Select Course"}</div>
                        <div className="points my-1">{courseDetails.teeName || "Select Tee"}</div>
                        {
                          courseDetails.holes && courseDetails.holes !== "Select Starting Hole" ? (
                            <div className="hole">
                              Hole: <span className="text-dark">{courseDetails.holes}</span>
                            </div>
                          ) : (
                            <div className="">Course Details</div>
                          )
                        }
                        {/* NEW: Display selected game format */}
                        <div className="gameFormat mt-1">
                          <span className="badge bg-primary">{courseDetails.gameFormat}</span>
                        </div>
                        {courseDetails.gameFormat && (
                          <div className="formatDesc text-muted small mt-1">
                            {getGameFormatDescription(courseDetails.gameFormat)}
                          </div>
                        )}
                      </div>
                    </div>
                    <button type="button" onClick={clubDetailEditModalOpen} className="btn p-0 shadow-none border-0 shadow-none align-self-baseline">
                      <img src={editIcon} />
                    </button>
                  </div>
                  <div className="clubPlayerOuter mb-4" >
                    <div className="clubPlayer d-flex align-items-center justify-content-between">
                      <div className="d-flex align-items-center gap-2">
                        <div className="imgOuter rounded-circle overflow-hidden">
                          <img className="w-100 h-100" src={
                            profile?.profilePic
                              ? `https://pwabucket1.s3.amazonaws.com/${profile?.profilePic}`
                              : `https://ui-avatars.com/api/?name=${encodeURIComponent(
                                profile?.name
                              )}&size=256`
                          } />
                        </div>
                        <div className="detail">
                          <div className="name">{profile?.name}</div>
                          <div className="dec mt-1">{profile?.country}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {selectedFriends?.map((friend, index) => (
                    <div className="clubPlayerOuter mb-4" key={index}>
                      <div className="clubPlayer d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center gap-2">
                          <div className="imgOuter rounded-circle overflow-hidden">
                            <img className="w-100 h-100" src={
                              friend?.profilePic
                                ? `https://pwabucket1.s3.amazonaws.com/${friend?.profilePic}`
                                : `https://ui-avatars.com/api/?name=${encodeURIComponent(
                                  friend?.name
                                )}&size=256`
                            } />
                          </div>
                          <div className="detail">
                            <div className="name">{friend?.name}</div>
                            <div className="dec mt-1">{friend?.country}</div>
                          </div>
                        </div>
                        <button type="button" className="btn btnClose bg-transparent p-0 shadow-none border-0" onClick={() => handleRemovePlayer(friend)}>
                          <img className="" src={closeIconDark} />
                        </button>
                      </div>
                    </div>
                  ))}

                  <button type="button" onClick={roundStart} className="btn btnStyle1 btnTheme2 btnWidth shadow-none px-3 w-100">
                    Start {courseDetails.gameFormat} Round
                  </button>
                  <div className="btnGroup d-flex flex-column flex-sm-row align-items-center gap-3 mt-4">
                    <button type="button" onClick={addPlayerModalOpen} className="btn btnStyle1 btnOutlineTheme1 btnWidth shadow-none px-3 w-100 d-flex align-items-center gap-1 justify-content-center"><img src={plusTheme1} /> Add Player</button>
                    <button type="button" onClick={playOnLeaderBoardModalOpen}  className="btn btnStyle1 btnTheme1 btnWidth shadow-none px-3 w-100">Play on Leaderboard</button>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xl-4 ">
              <div className="customCard rounded-3 bg-white d-flex flex-column flex-nowrap card-auto-h">
                <div className="customCardHeader p-3 pb-0">
                  <div className="d-flex gap-12 pb-3 border-bottom">
                    <div className="icon">
                      <img className="w-100" src={unfinishedRoundIcon} />
                    </div>
                    <div className="detail">
                      <div className="name">Unfinished Rounds</div>
                      <div className="dec mt-2">Do you want to resume a round that previously started?</div>
                    </div>
                  </div>
                </div>
                <div className="customCardBody p-3 flex-fill h-100 overflow-auto">
                  {getAllUnfinishedGames().map((game) => (

                        <div 
                          key={`${game.isLeaderboard ? 'leader' : 'regular'}-${game?._id}`} 
                          className="eventcard border-bottom p-0 d-flex flex-column gap-2 position-relative mb-3" 
                          onClick={() => {
                            // Use conditional logic to navigate based on game type
                            if (game.isLeaderboard) {
                              navigateToScoreLeaderKeepingPage(game?._id);
                            } else {
                              navigateToScoreKeepingPage(game?._id);
                            }
                          }}
                        >
{/* Leaderboard indicator */}
                      {game.isLeaderboard && (
                        <div className="position-absolute top-0 end-0 mt-1 me-4" style={{zIndex: 2}}>
                          <span className="badge bg-warning text-dark small fw-bold">
                            🏆 LEADERBOARD
                          </span>
                        </div>
                      )}
                      
                      <div className={`gameDetail d-flex align-items-center gap-2 ${game.isLeaderboard ? 'border-start border-warning border-3 ps-3' : ''}`}>
                        <div className="imgOuter">
                          <img className="w-100 h-100" src={
                            game?.gamePic
                              ? `https://pwabucket1.s3.amazonaws.com/${game?.gamePic}`
                              : `https://ui-avatars.com/api/?name=${encodeURIComponent(
                                game?.course?.name
                              )}&size=256`
                          } />
                        </div>
                        <div className="detail">
                          <div className="gameTitle d-flex align-items-center gap-2">
                            {game?.course?.name}
                            {game.isLeaderboard && (
                              <span className="text-warning" style={{fontSize: '14px'}}>🏆</span>
                            )}
                          </div>
                          <div className="gameScore d-flex align-items-center gap-1 mt-1">{game?.courseTeeData[0]?.name} {game?.courseTeeData[0]?.rating} / {game?.courseTeeData[0]?.slope}</div>
                          {/* Display game format */}
                          <div className="gameFormat mt-1">
                            <span className={`badge small ${game.isLeaderboard ? 'bg-warning text-dark' : 'bg-secondary'}`}>
                              {game?.gameFormat || "Stroke Play"}
                            </span>
                          </div>
                          <div className="competitionSize text-muted">{game?.teamSize}</div>
                          {game.isLeaderboard && (
                            <div className="leaderboardNote text-warning small fw-medium mt-1">
                              Live Competition
                            </div>
                          )}
                        </div>
                                       {!game.isLeaderboard && (
                                 <button type="button" className="btn btnClose border-0 shadow-none bg-transparent p-0 position-absolute top-0 end-0" onClick={(e) => {
                          e.stopPropagation();
                          gameDelete(game?._id);
                        }}>
                          <img className="" style={{ width: "14px" }} src={closeIconDark} alt="Close" />
                        </button>
                          )}

                      </div>
                      <div className="leaderProfile">
                        <div className="row g-2">
                          <div className="col-sm-6 text-start">
                            <div className="value">{game?.totalScore}</div>
                            <div className="title">Round Score</div>
                          </div>
                          <div className="col-sm-6 text-sm-end">
                            <div className="value">{game?.handicapScore}</div>
                            <div className="title">Handicap</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}

                  {getAllUnfinishedGames().length === 0 && (
                    <div className="text-center text-muted py-4">
                      <p>No unfinished rounds</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      </Main>

      {/* Club detail edit Modal */}
      <Modal show={clubDetailEditShow} className="headerModals" onHide={clubDetailEditModalClose} centered>
        <Modal.Header className="p-sm-4 p-3 position-relative justify-content-center" closeButton>
          <Modal.Title>
            <img src={logoVerticaleTheme} />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-sm-4 p-3">
          <Form className="row g-2" onSubmit={handleFormSubmit}>
            <Form.Label className="col-12 mb-0">Course Details</Form.Label>
            <Form.Group className="col-md-12">
              <Form.Control
                className="shadow-none"
                type="date"
                name="date"
                placeholder="MM/DD/YYYY"
                defaultValue={today.toISOString().split("T")[0]}
              />
            </Form.Group>

            <Form.Group className="col-sm-6 position-relative">
              <Form.Control
                type="text"
                placeholder="Search for a course..."
                value={searchQuery}
                onChange={handleSearchChange}
                onBlur={() => {
                  setTimeout(() => setShowSuggestions(false), 200);
                }}
                onFocus={() => {
                  if (searchQuery.trim()) {
                    setShowSuggestions(true);
                  }
                }}
              />

              {showSuggestions && filteredCourses.length > 0 && (
                <div className="suggestions-dropdown position-absolute w-100 bg-white border rounded mt-1 shadow-sm z-50" style={{ maxHeight: '200px', overflowY: 'auto' }}>
                  {filteredCourses.map((course) => (
                    <div
                      key={course._id}
                      className="suggestion-item p-2 border-bottom cursor-pointer hover:bg-light"
                      onClick={() => handleSuggestionClick(course)}
                      style={{ cursor: 'pointer' }}
                    >
                      {course.name}
                    </div>
                  ))}
                </div>
              )}
            </Form.Group>
            
            <Form.Group className="col-sm-6">
              <Form.Select
                as="select"
                name="course"
                value={courseDetails.course}
                onChange={(e) => {
                  fetchTeeData(e.target.value);
                  setCourseDetails({ ...courseDetails, course: e.target.value });
                  const selected = courseListData.filter(item => item.courseId == e.target.value)
                  console.log(selected, "selected");
                  handlechange(e)
                }}
              >
                <option value="">Select Course</option>
                {courseListData && courseListData?.map((course) => (
                  <option key={course?._id} value={course?.courseId}>
                    {course?.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
            
            <Form.Group className="col-sm-6">
              <Form.Select
                as="select"
                name="courseTee"
                value={courseDetails.courseTee}
                onChange={handlechange}
              >
                <option value="">Select Tees</option>
                {TeeData && TeeData?.map((tee) => (
                  <option key={tee.id} value={tee._id}>
                    {tee.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
            
            <Form.Group className="col-sm-6">
              <Form.Select
                aria-label="Default select example"
                name="holes"
              >
                <option>Select Starting Hole</option>
                <option value="18">18 Holes</option>
                <option value="9">Front 9</option>
                <option value="9">Back 9</option>
              </Form.Select>
            </Form.Group>

            {/* NEW: Game Format Selection */}
            <Form.Group className="col-12">
              <Form.Label>Game Format</Form.Label>
              <Form.Select
                name="gameFormat"
                value={courseDetails.gameFormat}
                onChange={handlechange}
              >
                <option value="Stroke Play">Stroke Play</option>
                <option value="Skins">Skins</option>
                <option value="Stableford">Stableford</option>
                <option value="Match Play">Match Play</option>
              </Form.Select>
            </Form.Group>

            {/* NEW: Game Format Description */}
            {courseDetails.gameFormat && (
              <Form.Group className="col-12">
                <div className="alert alert-info py-2 small">
                  <strong>{courseDetails.gameFormat}:</strong> {getGameFormatDescription(courseDetails.gameFormat)}
                </div>
              </Form.Group>
            )}

            {/* NEW: Format-specific rules */}
            {(courseDetails.gameFormat === "Skins" || courseDetails.gameFormat === "Stableford") && (
              <Form.Group className="col-12">
                <div className={`alert ${courseDetails.gameFormat === "Skins" ? "alert-warning" : "alert-info"} py-2 small`}>
                  <strong>{courseDetails.gameFormat} Rules:</strong>
                  <ul className="mb-0 mt-2 ps-3">
                    {getFormatRules(courseDetails.gameFormat).map((rule, index) => (
                      <li key={index}>{rule}</li>
                    ))}
                  </ul>
                </div>
              </Form.Group>
            )}

            <Form.Group className="col-12 mt-3 d-flex align-items-center">
              <Form.Check
                type="switch"
                id="privacy-switch"
                label={!formEndData.posts_privacy ? "Public Round " : "Private Round"}
                checked={formEndData.posts_privacy}
                onChange={togglePrivacyEnd}
              />
            </Form.Group>
            
            <Form.Group className="col-12 mt-4 text-end">
              <button type="submit" className="btn btnStyle1 btnTheme1 shadow-none px-5 w-100">Save</button>
            </Form.Group>
          </Form>
        </Modal.Body>
      </Modal>

      {/* Add Player Modal */}
      <Modal show={addPlayerShow} className="headerModals" onHide={addPlayerModalClose} centered>
        <Modal.Header className="p-sm-4 p-3 position-relative justify-content-center" closeButton>
          <Modal.Title>
            <img src={logoVerticaleTheme} />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-sm-4 p-3">
          <Form className="row gap-12">
            <Form.Group className="col-12 position-relative">
              <Form.Label htmlFor="contactSearch" style={{ cursor: "pointer" }} className="position-absolute top-0 bottom-0 my-auto end-0 me-3 d-flex align-items-center justify-content-center">
                <img src={searchIcon} />
              </Form.Label>
              <Form.Control
                className="pe-5"
                type="search"
                id="contactSearch"
                placeholder="Search by username"
                aria-describedby="passwordHelpBlock"
                value={searchDataQuery}
                onChange={handleDataSearch}
              />
            </Form.Group>
            <Form.Group className="col-md-12 selectPlayerOuter">
              {filteredFriendList?.map((friend) => (
                <Form.Check
                  key={friend?._id}
                  className="selectPlayerCheck m-0 p-0 d-flex align-items-center justify-content-between flex-row-reverse"
                  name="group1"
                  type="checkbox"
                  id={`player${friend?._id}`} // Ensure the id is unique for each friend
                  onChange={() => handleCheckboxChange(friend?._id, friend?.name, friend?.profilePic)}
                  checked={selectedFriends.some(selectedFriend => selectedFriend?.id === friend?._id)}
                  label={
                    <div className="playerPro d-flex align-items-center gap-2">
                      <div className="playerImg overflow-hidden rounded-circle">
                        <img
                          className="w-100 h-100"
                          src={
                            friend?.profilePic
                              ? `https://pwabucket1.s3.amazonaws.com/${friend?.profilePic}`
                              : `https://ui-avatars.com/api/?name=${encodeURIComponent(
                                friend?.name
                              )}&size=256`
                          }
                          alt="Friend Profile"
                        />
                      </div>
                      <div className="detail">
                        <div className="name">{friend.name}</div> {/* Use friend's name here */}
                        <div className="dec mt-1">{friend.location}</div> {/* Use friend's location here */}
                      </div>
                    </div>
                  }
                />
              ))}
            </Form.Group>
            <Form.Group className="col-12 mt-4 text-end">
              <button type="button" className="btn btnStyle1 btnTheme1 shadow-none px-5 w-100" onClick={addPlayerData}>Add Players</button>
            </Form.Group>
          </Form>
        </Modal.Body>
      </Modal>

      {/* Play on leaderboard Modal  */}
      <Modal show={playOnLeaderBoardShow} className="headerModals" onHide={playOnLeaderBoardModalClose} centered>
        <Modal.Header className="p-sm-4 p-3 position-relative justify-content-center" closeButton>
          <Modal.Title>
            <img src={logoVerticaleTheme} />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-sm-4 p-3">
          <div className="row gap-3">
            <div className="col-12 text-center mb-3">
              <img src={scoreCardModalImg} />
              <div className="mt-3 d-flex align-items-center justify-content-center gap-2 fs-6 fw-medium text-dark">
                Play on Leader board
                <button type="button" onClick={scoreCardStepModalOpen} className="p-0 border-0 p-0 bg-transparent"><img src={noteIcon} /></button>
              </div>
              <div className="dec mt-1 text-muted w-75 mx-auto fs-14 fw-medium">Complete live with a large group by creating or joining an existing group.</div>
            </div>
            <div className="col-12 d-flex flex-column gap-3">
              <button type="button" onClick={() => navigate("/leader-board")} className="btn textBtn screCardBtn border-0 text-start bg-transparent fw-medium text-dark d-flex align-items-center gap-12 position-relative">
                <div className="icon">
                  <img src={tabIcon1} />
                </div>
                <div className="">
                  <div className="title">Create</div>
                  <div className="dec text-muted fw-normal fs-14">New group or competition</div>
                </div>
              </button>
              <button type="button" onClick={() => navigate("/current-leaderboard")} className="btn textBtn screCardBtn border-0 text-start bg-transparent fw-medium text-dark d-flex align-items-center gap-12 position-relative">
                <div className="icon">
                  <img src={tabIcon1} />
                </div>
                <div className="">
                  <div className="title">Join</div>
                  <div className="dec text-muted fw-normal fs-14">Track score while playing</div>
                </div>
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* How it work Modal  */}
      <Modal show={show} size="lg" className="headerModals" onHide={scoreCardStepModalClose} centered>
        <Modal.Header className="p-sm-4 p-3 position-relative justify-content-center" closeButton>
          <Modal.Title>
            <img src={logoVerticaleTheme} />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-sm-4 p-3">
          <div className="row g-3 align-items-center">
            <div className="col-lg-4 col-md-6 text-center">
              <img src={scoreCardModalImg} />
            </div>
            <div className="col-lg-8 col-md-6">
              <div className="title fs-6 fw-medium">The Best way to Compete!</div>
              <div className="dec fs-14 mt-1 text-muted">Live leader boards allow you to get real time updates of how your buddies are playing, even if hey are in a different foursome!</div>
              <ul className="p-0 m-0 list-unstyled d-flex flex-column gap-sm-4 gap-3 mt-sm-4 mt-3">
                <li className="">
                  <div className="d-flex align-items-center gap-1 fs-14 fw-medium"><img src={golfIcon} /> See Where You Stand:</div>
                  <div className="fs-12 text-muted fw-medium">Click on the Ranking icon to see the leader board table and how you rank.</div>
                </li>
                <li className="">
                  <div className="d-flex align-items-center gap-1 fs-14 fw-medium"><img src={golfIcon} />Track Foursome Score:</div>
                  <div className="fs-12 text-muted fw-medium">Track up to 4 scores in your phone to feed the leader board.</div>
                </li>
              </ul>
              <div className="fs-14 fw-medium text-dark mt-4">NOTE: Make sure to complete your upload at the end to post scores.</div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>

  );
}
export default Play;


// import React, { useState, useEffect } from "react";
// import Main from "../components/layout/Main";
// import closeIconDark from "../assets/images/closeIconDark.png";
// import editIcon from "../assets/images/editIcon.png";
// import carbonFilter from "../assets/images/carbonFilter.png";
// import plusTheme1 from "../assets/images/plusTheme1.png";
// import gameImg from "../assets/images/gameImg.png";
// import unfinishedRoundIcon from "../assets/images/unfinishedRoundIcon.png";
// import { useNavigate } from "react-router-dom";
// import Form from 'react-bootstrap/Form';
// import logoVerticaleTheme from "../assets/images/logoVerticaleTheme.png";
// import Modal from 'react-bootstrap/Modal';
// import searchIcon from "../assets/images/searchIcon.png";
// import tabIcon1 from "../assets/images/tabIcon1.png";
// import scoreCardModalImg from "../assets/images/scoreCardModalImg.png";
// import golfIcon from "../assets/images/golfIcon.png";
// import noteIcon from "../assets/images/noteIcon.png";
// import useRequest from "../../src/hooks/useRequest"
// import { Severty, ShowToast } from "../helper/toast";
// import useGeolocation from './useGeolocation';

// function Play() {
//   const [TeeData, setTeeData] = useState([])
//   const [searchQuery, setSearchQuery] = useState('');
//   const [courseDetails, setCourseDetails] = useState({
//     date: "", 
//     course: "",
//     courseId: "",
//     courseTee: "",
//     teeName: "", 
//     courseName: "", 
//     holes: "",
//     gameFormat: "Stroke Play", // NEW: Game format field
//   });
//   const [formEndData, setFormEndData] = useState({
//     posts_privacy: true,
//   });

//   // Add method to toggle privacy
//   const togglePrivacyEnd = () => {
//     setFormEndData(prevData => ({
//       ...prevData,
//       posts_privacy: !prevData.posts_privacy
//     }));
//     console.log("formEndData", formEndData.posts_privacy)
//   };

//   const handlechange = (event) => {
//     const { name, value } = event.target;
//     setCourseDetails({
//       ...courseDetails,
//       [name]: value,
//     });
//     if (name === 'course') {
//       const selectedCourse = courseListData.find(course => course.courseId === value);
//       setCourseDetails(prevState => ({
//         ...prevState,
//         courseName: selectedCourse?.name || "",
//       }));
//     } else if (name === 'courseTee') {
//       const selectedTee = TeeData.find(tee => tee._id === value);
//       setCourseDetails(prevState => ({
//         ...prevState,
//         teeName: selectedTee?.name || "",
//       }));
//     }
//   };

//   // NEW: Game format descriptions
//   const getGameFormatDescription = (format) => {
//     switch (format) {
//       case "Stroke Play":
//         return "Traditional stroke counting - lowest total score wins";
//       case "Skins":
//         return "Win individual holes - lowest score on each hole wins a 'skin'";
//       case "Stableford":
//         return "Points-based scoring - earn points based on score relative to par";
//       case "Match Play":
//         return "Head-to-head competition - win individual holes";
//       default:
//         return "";
//     }
//   };

//   // NEW: Get format-specific rules
//   const getFormatRules = (format) => {
//     switch (format) {
//       case "Skins":
//         return [
//           "Lowest score on each hole wins the skin",
//           "Tied holes carry over to the next hole", 
//           "Winner takes all carried-over skins"
//         ];
//       case "Stableford":
//         return [
//           "Eagle or better: 4 points",
//           "Birdie: 3 points", 
//           "Par: 2 points",
//           "Bogey: 1 point",
//           "Double bogey+: 0 points"
//         ];
//       case "Match Play":
//         return [
//           "Win individual holes head-to-head",
//           "Best overall hole record wins",
//           "Halved holes don't count toward either player"
//         ];
//       default:
//         return [];
//     }
//   };

//   const [filteredCourses, setFilteredCourses] = useState([]);
//   const [showSuggestions, setShowSuggestions] = useState(false);

//   const { request } = useRequest();
//   const [selectedFriends, setSelectedFriends] = useState([]);
//   const [friendList, setFriendList] = useState([]);
//   const [profile, setProfile] = useState({});
//   const [courseListData, setCourseListData] = useState([])
//   const [allGame, setAllGame] = useState([])
//   const [allLeaderGame, setAllLeaderGame] = useState([])
//   const [addplayer, setAddPlayer] = useState()

//   const navigate = useNavigate();

//   const [clubDetailEditShow, clubDetailEditModal] = useState(false);
//   const clubDetailEditModalClose = () => clubDetailEditModal(false);
//   const clubDetailEditModalOpen = () => clubDetailEditModal(true);

//   const [addPlayerShow, addPlayerModal] = useState(false);
//   const addPlayerModalClose = () => addPlayerModal(false);
//   const addPlayerModalOpen = (fetchFriendList) => addPlayerModal(true);
//   const [searchDataQuery, setDataSearchQuery] = useState('');
//   const [filteredFriendList, setFilteredFriendList] = useState([]);
//   const { location } = useGeolocation();

//   useEffect(() => {
//     unfinishedGame()
//   }, [])
  
//   useEffect(() => {
//     let latitude = null;
//     let longitude = null;

//     const storedLocation = JSON.parse(localStorage.getItem('userLocation'));
//     if (storedLocation) {
//       latitude = storedLocation.latitude;
//       longitude = storedLocation.longitude;
//     } else {
//       latitude = location.latitude;
//       longitude = location.longitude;
//     }

//     request({
//       url: `/common/getNewcourse?search=${encodeURIComponent(searchQuery)}&latitude=${latitude}&longitude=${longitude}`,
//       method: "GET",
//       onSuccess: (data) => {
//         console.log(data);
//         setCourseListData(data.data.docs);
//       },
//       onError: (error) => {
//         console.log(error);
//       },
//     });
//     fetchFriendList();
//     setUserProfile();
//     unfinishedGame();
//   }, [searchQuery]);

//   const fetchTeeData = (id) => {
//     request({
//       url: `/common/getCourseTeeData/${id}`,
//       method: "GET",
//       onSuccess: (data) => {
//         console.log("getCourseTeeData", data)
//         setTeeData(data.data.data);
//       },
//       onError: (error) => {
//         console.log(error);
//       },
//     })
//   }

//   const unfinishedGame = () => {
//     request({
//       url: `app/game/get-user-game`,
//       method: "GET",
//       onSuccess: (data) => {
//         console.log("get-user-game", data)
//         setAllGame(data.data.docs);
//       },
//       onError: (error) => {
//         console.log(error);
//       },
//     })

//     request({
//       url: `app/game/get-user-game-on-leaderboard`,
//       method: "GET",
//       onSuccess: (data) => {
//         console.log("get-user-game-on-leaderboard", data)
//         setAllLeaderGame(data.data.docs);
//       },
//       onError: (error) => {
//         console.log(error);
//       },
//     })

//   }

//   const today = new Date();
//   const formattedDate = `${(today.getMonth() + 1).toString().padStart(2, '0')}${today.getDate().toString().padStart(2, '0')}${today.getFullYear()}`;

//   const [playOnLeaderBoardShow, playOnLeaderBoardModal] = useState(false);
//   const playOnLeaderBoardModalClose = () => playOnLeaderBoardModal(false);
//   const playOnLeaderBoardModalOpen = () => playOnLeaderBoardModal(true);

//   const [show, scoreCardStepModal] = useState(false);
//   const scoreCardStepModalClose = () => scoreCardStepModal(false);
//   const scoreCardStepModalOpen = () => {
//     scoreCardStepModal(true)
//     playOnLeaderBoardModal(false)
//   };

//   const setUserProfile = () => {
//     request({
//       url: "app/user/get-profile",
//       method: "GET",
//       onSuccess: (data) => {
//         console.log("Profile data:", data.data.name);
//         setProfile(data.data);
//       },
//       onError: (error) => {
//         console.log("Error fetching profile:", error);
//       }
//     });
//   };
//   const userId = profile?._id
//   const fetchFriendList = () => {
//     request({
//       url: "/app/friend/user-friend-list",
//       method: "GET",
//       onSuccess: (data) => {
//         console.log("user-friend-list", data);
//         setFriendList(data.data.data);
//       },
//       onError: (error) => {
//         console.log(error);
//       },
//     });
//   };

//   useEffect(()=>{
//       fetchFriendList()
//   },[])
  
//   useEffect(() => {
//     setFilteredFriendList(friendList);
//   }, [addPlayerModalClose,addPlayerModalOpen, friendList]);
  
//   // Function to handle search
//   const handleDataSearch = (e) => {
//     const query = e.target.value;
//     setDataSearchQuery(query);

//     const filteredFriends = friendList.filter(friend =>
//       friend.name.toLowerCase().includes(query.toLowerCase())
//     );
//     setFilteredFriendList(filteredFriends);
//   };

//   const handleCheckboxChange = (friendId, friendName, profilePic) => {
//     const isFriendSelected = selectedFriends.some(friend => friend.id === friendId);
//     if (isFriendSelected) {
//       const updatedSelectedFriends = selectedFriends.filter(friend => friend.id !== friendId);
//       setSelectedFriends(updatedSelectedFriends);
//     } else {
//       setSelectedFriends([...selectedFriends, { id: friendId, name: friendName, profilePic: profilePic }]);
//     }
//   };

//   const addPlayerData = () => {
//     console.log("selectedfriends", selectedFriends);
//     setAddPlayer(selectedFriends);
//     addPlayerModalClose();
//   };

//   const handleRemovePlayer = (friendToRemove) => {
//     const updatedSelectedFriends = selectedFriends.filter(friend => friend.id !== friendToRemove.id);
//     setSelectedFriends(updatedSelectedFriends);
//   };

//   const handleFormSubmit = (event) => {
//     event.preventDefault();
//     const formData = {
//       date: event?.target?.date?.value,
//       course: courseDetails.courseName,
//       courseId: courseDetails.course,
//       courseTee: courseDetails.teeName,
//       courseTeeId: courseDetails.courseTee,
//       holes: event?.target?.holes?.value,
//       gameFormat: event?.target?.gameFormat?.value || "Stroke Play", // NEW: Game format
//     };
//     setCourseDetails(formData);
//     clubDetailEditModalClose()
//     console.log("formEndData", formEndData.posts_privacy)
//   };

//   const roundStart = (event) => {
//     event.preventDefault();
//     if (courseDetails && courseDetails.course && courseDetails.holes) {
//       const playersIds = selectedFriends?.map(player => player?.id) || [];
//       const startRoundData = {
//         course: courseDetails.courseId,
//         courseTee: courseDetails.courseTeeId ? courseDetails.courseTeeId : null,
//         holes: courseDetails.holes,
//         score: "Net",
//         primaryStat: "",
//         players: [...playersIds, userId],
//         isFinished: true,
//         posts_privacy: formEndData.posts_privacy,
//         gameFormat: courseDetails.gameFormat, // NEW: Include game format
//       };
//       request({
//         url: "/app/game/create-game",
//         method: "POST",
//         data: startRoundData,
//         onSuccess: (data) => {
//           const gameId = data.data._id;
//           navigate(`/score-keeping/${gameId}`, { state: { response: data.data } });
//         },
//         onError: (error) => {
//           console.log(error);
//         },
//       });
//     } else {
//       console.log("please all detail fill")
//       ShowToast('Please fill all course details.', Severty.ERROR);
//     }
//   };

//   const handleSearchChange = (event) => {
//     const query = event.target.value;
//     setSearchQuery(query);

//     if (query.trim()) {
//       const filtered = courseListData.filter(course =>
//         course.name.toLowerCase().includes(query.toLowerCase())
//       );
//       setFilteredCourses(filtered);
//       setShowSuggestions(true);
//     } else {
//       setFilteredCourses([]);
//       setShowSuggestions(false);
//     }
//   };

//   const handleSuggestionClick = (course) => {
//     setSearchQuery(course.name);
//     fetchTeeData(course.courseId);
//     setCourseDetails({
//       ...courseDetails,
//       course: course.courseId,
//       courseName: course.name
//     });
//     setShowSuggestions(false);
//   };

//   function navigateToScoreKeepingPage(gameId) {
//     window.location.href = `/score-keeping/${gameId}`;
//   }

//   const gameDelete = (id) => {
//     console.log("check the data value ")
//     request({
//       url: `/app/game/game-delete/${id}`,
//       method: "Delete",
//       onSuccess: (data) => {
//         unfinishedGame()
//         ShowToast('Game Deleted Successfully.', Severty.SUCCESS);
//       },
//       onError: (error) => {
//         console.log(error);
//       },
//     });
//   };

//   return (
//     <>
//       <Main>
//         <section className="home-wrap playPageOuter  px-lg-4 px-3 pb-lg-4 pb-3 container-fluid">
//           <div className="row g-3 ">
//             <div className="col-xl-8">
//               <div className="customCard rounded-3 bg-white d-flex flex-column flex-nowrap h-100">
//                 <div className="customCardHeader pb-0">
//                   <div className="title pb-3 border-bottom">Round Setup</div>
//                 </div>
//                 <div className="customCardBody flex-fill h-100 overflow-auto">
//                   <div className="golfClubDetail pb-3 d-flex align-items-center justify-content-between">
//                     <div className=" d-flex align-items-center gap-12">
//                       <div className="icon">
//                         <img src={carbonFilter} />
//                       </div>
//                       <div className="detail">
//                         <div className="name">{courseDetails.courseName || "Select Course"}</div>
//                         <div className="points my-1">{courseDetails.teeName || "Select Tee"}</div>
//                         {
//                           courseDetails.holes && courseDetails.holes !== "Select Starting Hole" ? (
//                             <div className="hole">
//                               Hole: <span className="text-dark">{courseDetails.holes}</span>
//                             </div>
//                           ) : (
//                             <div className="">Course Details</div>
//                           )
//                         }
//                         {/* NEW: Display selected game format */}
//                         <div className="gameFormat mt-1">
//                           <span className="badge bg-primary">{courseDetails.gameFormat}</span>
//                         </div>
//                         {courseDetails.gameFormat && (
//                           <div className="formatDesc text-muted small mt-1">
//                             {getGameFormatDescription(courseDetails.gameFormat)}
//                           </div>
//                         )}
//                       </div>
//                     </div>
//                     <button type="button" onClick={clubDetailEditModalOpen} className="btn p-0 shadow-none border-0 shadow-none align-self-baseline">
//                       <img src={editIcon} />
//                     </button>
//                   </div>
//                   <div className="clubPlayerOuter mb-4" >
//                     <div className="clubPlayer d-flex align-items-center justify-content-between">
//                       <div className="d-flex align-items-center gap-2">
//                         <div className="imgOuter rounded-circle overflow-hidden">
//                           <img className="w-100 h-100" src={
//                             profile?.profilePic
//                               ? `https://pwabucket1.s3.amazonaws.com/${profile?.profilePic}`
//                               : `https://ui-avatars.com/api/?name=${encodeURIComponent(
//                                 profile?.name
//                               )}&size=256`
//                           } />
//                         </div>
//                         <div className="detail">
//                           <div className="name">{profile?.name}</div>
//                           <div className="dec mt-1">{profile?.country}</div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                   {selectedFriends?.map((friend, index) => (
//                     <div className="clubPlayerOuter mb-4" key={index}>
//                       <div className="clubPlayer d-flex align-items-center justify-content-between">
//                         <div className="d-flex align-items-center gap-2">
//                           <div className="imgOuter rounded-circle overflow-hidden">
//                             <img className="w-100 h-100" src={
//                               friend?.profilePic
//                                 ? `https://pwabucket1.s3.amazonaws.com/${friend?.profilePic}`
//                                 : `https://ui-avatars.com/api/?name=${encodeURIComponent(
//                                   friend?.name
//                                 )}&size=256`
//                             } />
//                           </div>
//                           <div className="detail">
//                             <div className="name">{friend?.name}</div>
//                             <div className="dec mt-1">{friend?.country}</div>
//                           </div>
//                         </div>
//                         <button type="button" className="btn btnClose bg-transparent p-0 shadow-none border-0" onClick={() => handleRemovePlayer(friend)}>
//                           <img className="" src={closeIconDark} />
//                         </button>
//                       </div>
//                     </div>
//                   ))}

//                   <button type="button" onClick={roundStart} className="btn btnStyle1 btnTheme2 btnWidth shadow-none px-3 w-100">
//                     Start {courseDetails.gameFormat} Round
//                   </button>
//                   <div className="btnGroup d-flex flex-column flex-sm-row align-items-center gap-3 mt-4">
//                     <button type="button" onClick={addPlayerModalOpen} className="btn btnStyle1 btnOutlineTheme1 btnWidth shadow-none px-3 w-100 d-flex align-items-center gap-1 justify-content-center"><img src={plusTheme1} /> Add Player</button>
//                     <button type="button" onClick={playOnLeaderBoardModalOpen}  className="btn btnStyle1 btnTheme1 btnWidth shadow-none px-3 w-100">Play on Leaderboard</button>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="col-xl-4 ">
//               <div className="customCard rounded-3 bg-white d-flex flex-column flex-nowrap card-auto-h">
//                 <div className="customCardHeader p-3 pb-0">
//                   <div className="d-flex gap-12 pb-3 border-bottom">
//                     <div className="icon">
//                       <img className="w-100" src={unfinishedRoundIcon} />
//                     </div>
//                     <div className="detail">
//                       <div className="name">Unfinished Rounds</div>
//                       <div className="dec mt-2">Do you want to resume a round that previously started?</div>
//                     </div>
//                   </div>
//                 </div>
//                 <div className="customCardBody p-3 flex-fill h-100 overflow-auto">
//                   {allGame?.filter(game => !game.isFinished).map((game) => (
//                     <div key={game?._id} className="eventcard border-bottom p-0 d-flex flex-column gap-2 position-relative" onClick={() => navigateToScoreKeepingPage(game?._id)} >
//                       <div className="gameDetail d-flex align-items-center gap-2">
//                         <div className="imgOuter">
//                           <img className="w-100 h-100" src={
//                             game?.gamePic
//                               ? `https://pwabucket1.s3.amazonaws.com/${game?.gamePic}`
//                               : `https://ui-avatars.com/api/?name=${encodeURIComponent(
//                                 game?.course?.name
//                               )}&size=256`
//                           } />
//                         </div>
//                         <div className="detail">
//                           <div className="gameTitle">{game?.course?.name}</div>
//                           <div className="gameScore d-flex align-items-center gap-1 mt-1">{game?.courseTeeData[0]?.name} {game?.courseTeeData[0]?.rating} / {game?.courseTeeData[0]?.slope}</div>
//                           {/* NEW: Display game format in unfinished games */}
//                           <div className="gameFormat mt-1">
//                             <span className="badge bg-secondary small">{game?.gameFormat || "Stroke Play"}</span>
//                           </div>
//                           <div className="competitionSize text-muted">{game?.teamSize}</div>
//                         </div>
//                         <button type="button" className="btn btnClose border-0 shadow-none bg-transparent p-0 position-absolute top-0 end-0" onClick={(e) => {
//                           e.stopPropagation();
//                           gameDelete(game?._id);
//                         }}>
//                           <img className="" style={{ width: "14px" }} src={closeIconDark} alt="Close" />
//                         </button>
//                       </div>
//                       <div className="leaderProfile">
//                         <div className="row g-2">
//                           <div className="col-sm-6 text-start">
//                             <div className="value">{game?.totalScore}</div>
//                             <div className="title">Round Score</div>
//                           </div>
//                           <div className="col-sm-6 text-sm-end">
//                             <div className="value">{game?.handicapScore}</div>
//                             <div className="title">Handicap</div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//                                       <div className="name">leaderboard Rounds</div>

//                   {allLeaderGame?.filter(game => !game.isFinished).map((game) => (
//                     <div key={game?._id} className="eventcard border-bottom p-0 d-flex flex-column gap-2 position-relative" onClick={() => navigateToScoreKeepingPage(game?._id)} >
//                       <div className="gameDetail d-flex align-items-center gap-2">
//                         <div className="imgOuter">
//                           <img className="w-100 h-100" src={
//                             game?.gamePic
//                               ? `https://pwabucket1.s3.amazonaws.com/${game?.gamePic}`
//                               : `https://ui-avatars.com/api/?name=${encodeURIComponent(
//                                 game?.course?.name
//                               )}&size=256`
//                           } />
//                         </div>
//                         <div className="detail">
//                           <div className="gameTitle">{game?.course?.name}</div>
//                           <div className="gameScore d-flex align-items-center gap-1 mt-1">{game?.courseTeeData[0]?.name} {game?.courseTeeData[0]?.rating} / {game?.courseTeeData[0]?.slope}</div>
//                           {/* NEW: Display game format in unfinished games */}
//                           <div className="gameFormat mt-1">
//                             <span className="badge bg-secondary small">{game?.gameFormat || "Stroke Play"}</span>
//                           </div>
//                           <div className="competitionSize text-muted">{game?.teamSize}</div>
//                         </div>
//                         <button type="button" className="btn btnClose border-0 shadow-none bg-transparent p-0 position-absolute top-0 end-0" onClick={(e) => {
//                           e.stopPropagation();
//                           gameDelete(game?._id);
//                         }}>
//                           <img className="" style={{ width: "14px" }} src={closeIconDark} alt="Close" />
//                         </button>
//                       </div>
//                       <div className="leaderProfile">
//                         <div className="row g-2">
//                           <div className="col-sm-6 text-start">
//                             <div className="value">{game?.totalScore}</div>
//                             <div className="title">Round Score</div>
//                           </div>
//                           <div className="col-sm-6 text-sm-end">
//                             <div className="value">{game?.handicapScore}</div>
//                             <div className="title">Handicap</div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   ))}


//               </div>
//             </div>



//           </div>
//         </section>
//       </Main>

//       {/* Club detail edit Modal */}
//       <Modal show={clubDetailEditShow} className="headerModals" onHide={clubDetailEditModalClose} centered>
//         <Modal.Header className="p-sm-4 p-3 position-relative justify-content-center" closeButton>
//           <Modal.Title>
//             <img src={logoVerticaleTheme} />
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body className="p-sm-4 p-3">
//           <Form className="row g-2" onSubmit={handleFormSubmit}>
//             <Form.Label className="col-12 mb-0">Course Details</Form.Label>
//             <Form.Group className="col-md-12">
//               <Form.Control
//                 className="shadow-none"
//                 type="date"
//                 name="date"
//                 placeholder="MM/DD/YYYY"
//                 defaultValue={today.toISOString().split("T")[0]}
//               />
//             </Form.Group>

//             <Form.Group className="col-sm-6 position-relative">
//               <Form.Control
//                 type="text"
//                 placeholder="Search for a course..."
//                 value={searchQuery}
//                 onChange={handleSearchChange}
//                 onBlur={() => {
//                   setTimeout(() => setShowSuggestions(false), 200);
//                 }}
//                 onFocus={() => {
//                   if (searchQuery.trim()) {
//                     setShowSuggestions(true);
//                   }
//                 }}
//               />

//               {showSuggestions && filteredCourses.length > 0 && (
//                 <div className="suggestions-dropdown position-absolute w-100 bg-white border rounded mt-1 shadow-sm z-50" style={{ maxHeight: '200px', overflowY: 'auto' }}>
//                   {filteredCourses.map((course) => (
//                     <div
//                       key={course._id}
//                       className="suggestion-item p-2 border-bottom cursor-pointer hover:bg-light"
//                       onClick={() => handleSuggestionClick(course)}
//                       style={{ cursor: 'pointer' }}
//                     >
//                       {course.name}
//                     </div>
//                   ))}
//                 </div>
//               )}
//             </Form.Group>
            
//             <Form.Group className="col-sm-6">
//               <Form.Select
//                 as="select"
//                 name="course"
//                 value={courseDetails.course}
//                 onChange={(e) => {
//                   fetchTeeData(e.target.value);
//                   setCourseDetails({ ...courseDetails, course: e.target.value });
//                   const selected = courseListData.filter(item => item.courseId == e.target.value)
//                   console.log(selected, "selected");
//                   handlechange(e)
//                 }}
//               >
//                 <option value="">Select Course</option>
//                 {courseListData && courseListData?.map((course) => (
//                   <option key={course?._id} value={course?.courseId}>
//                     {course?.name}
//                   </option>
//                 ))}
//               </Form.Select>
//             </Form.Group>
            
//             <Form.Group className="col-sm-6">
//               <Form.Select
//                 as="select"
//                 name="courseTee"
//                 value={courseDetails.courseTee}
//                 onChange={handlechange}
//               >
//                 <option value="">Select Tees</option>
//                 {TeeData && TeeData?.map((tee) => (
//                   <option key={tee.id} value={tee._id}>
//                     {tee.name}
//                   </option>
//                 ))}
//               </Form.Select>
//             </Form.Group>
            
//             <Form.Group className="col-sm-6">
//               <Form.Select
//                 aria-label="Default select example"
//                 name="holes"
//               >
//                 <option>Select Starting Hole</option>
//                 <option value="18">18 Holes</option>
//                 <option value="9">Front 9</option>
//                 <option value="9">Back 9</option>
//               </Form.Select>
//             </Form.Group>

//             {/* NEW: Game Format Selection */}
//             <Form.Group className="col-12">
//               <Form.Label>Game Format</Form.Label>
//               <Form.Select
//                 name="gameFormat"
//                 value={courseDetails.gameFormat}
//                 onChange={handlechange}
//               >
//                 <option value="Stroke Play">Stroke Play</option>
//                 <option value="Skins">Skins</option>
//                 <option value="Stableford">Stableford</option>
//                 <option value="Match Play">Match Play</option>
//               </Form.Select>
//             </Form.Group>

//             {/* NEW: Game Format Description */}
//             {courseDetails.gameFormat && (
//               <Form.Group className="col-12">
//                 <div className="alert alert-info py-2 small">
//                   <strong>{courseDetails.gameFormat}:</strong> {getGameFormatDescription(courseDetails.gameFormat)}
//                 </div>
//               </Form.Group>
//             )}

//             {/* NEW: Format-specific rules */}
//             {(courseDetails.gameFormat === "Skins" || courseDetails.gameFormat === "Stableford") && (
//               <Form.Group className="col-12">
//                 <div className={`alert ${courseDetails.gameFormat === "Skins" ? "alert-warning" : "alert-info"} py-2 small`}>
//                   <strong>{courseDetails.gameFormat} Rules:</strong>
//                   <ul className="mb-0 mt-2 ps-3">
//                     {getFormatRules(courseDetails.gameFormat).map((rule, index) => (
//                       <li key={index}>{rule}</li>
//                     ))}
//                   </ul>
//                 </div>
//               </Form.Group>
//             )}

//             <Form.Group className="col-12 mt-3 d-flex align-items-center">
//               <Form.Check
//                 type="switch"
//                 id="privacy-switch"
//                 label={!formEndData.posts_privacy ? "Public Round " : "Private Round"}
//                 checked={formEndData.posts_privacy}
//                 onChange={togglePrivacyEnd}
//               />
//             </Form.Group>
            
//             <Form.Group className="col-12 mt-4 text-end">
//               <button type="submit" className="btn btnStyle1 btnTheme1 shadow-none px-5 w-100">Save</button>
//             </Form.Group>
//           </Form>
//         </Modal.Body>
//       </Modal>

//       {/* Add Player Modal */}
//       <Modal show={addPlayerShow} className="headerModals" onHide={addPlayerModalClose} centered>
//         <Modal.Header className="p-sm-4 p-3 position-relative justify-content-center" closeButton>
//           <Modal.Title>
//             <img src={logoVerticaleTheme} />
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body className="p-sm-4 p-3">
//           <Form className="row gap-12">
//             <Form.Group className="col-12 position-relative">
//               <Form.Label htmlFor="contactSearch" style={{ cursor: "pointer" }} className="position-absolute top-0 bottom-0 my-auto end-0 me-3 d-flex align-items-center justify-content-center">
//                 <img src={searchIcon} />
//               </Form.Label>
//               <Form.Control
//                 className="pe-5"
//                 type="search"
//                 id="contactSearch"
//                 placeholder="Search by username"
//                 aria-describedby="passwordHelpBlock"
//                 value={searchDataQuery}
//                 onChange={handleDataSearch}
//               />
//             </Form.Group>
//             <Form.Group className="col-md-12 selectPlayerOuter">
//               {filteredFriendList?.map((friend) => (
//                 <Form.Check
//                   key={friend?._id}
//                   className="selectPlayerCheck m-0 p-0 d-flex align-items-center justify-content-between flex-row-reverse"
//                   name="group1"
//                   type="checkbox"
//                   id={`player${friend?._id}`} // Ensure the id is unique for each friend
//                   onChange={() => handleCheckboxChange(friend?._id, friend?.name, friend?.profilePic)}
//                   checked={selectedFriends.some(selectedFriend => selectedFriend?.id === friend?._id)}
//                   label={
//                     <div className="playerPro d-flex align-items-center gap-2">
//                       <div className="playerImg overflow-hidden rounded-circle">
//                         <img
//                           className="w-100 h-100"
//                           src={
//                             friend?.profilePic
//                               ? `https://pwabucket1.s3.amazonaws.com/${friend?.profilePic}`
//                               : `https://ui-avatars.com/api/?name=${encodeURIComponent(
//                                 friend?.name
//                               )}&size=256`
//                           }
//                           alt="Friend Profile"
//                         />
//                       </div>
//                       <div className="detail">
//                         <div className="name">{friend.name}</div> {/* Use friend's name here */}
//                         <div className="dec mt-1">{friend.location}</div> {/* Use friend's location here */}
//                       </div>
//                     </div>
//                   }
//                 />
//               ))}
//             </Form.Group>
//             <Form.Group className="col-12 mt-4 text-end">
//               <button type="button" className="btn btnStyle1 btnTheme1 shadow-none px-5 w-100" onClick={addPlayerData}>Add Players</button>
//             </Form.Group>
//           </Form>
//         </Modal.Body>
//       </Modal>

//       {/* Play on leaderboard Modal  */}
//       <Modal show={playOnLeaderBoardShow} className="headerModals" onHide={playOnLeaderBoardModalClose} centered>
//         <Modal.Header className="p-sm-4 p-3 position-relative justify-content-center" closeButton>
//           <Modal.Title>
//             <img src={logoVerticaleTheme} />
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body className="p-sm-4 p-3">
//           <div className="row gap-3">
//             <div className="col-12 text-center mb-3">
//               <img src={scoreCardModalImg} />
//               <div className="mt-3 d-flex align-items-center justify-content-center gap-2 fs-6 fw-medium text-dark">
//                 Play on Leader board
//                 <button type="button" onClick={scoreCardStepModalOpen} className="p-0 border-0 p-0 bg-transparent"><img src={noteIcon} /></button>
//               </div>
//               <div className="dec mt-1 text-muted w-75 mx-auto fs-14 fw-medium">Complete live with a large group by creating or joining an existing group.</div>
//             </div>
//             <div className="col-12 d-flex flex-column gap-3">
//               <button type="button" onClick={() => navigate("/leader-board")} className="btn textBtn screCardBtn border-0 text-start bg-transparent fw-medium text-dark d-flex align-items-center gap-12 position-relative">
//                 <div className="icon">
//                   <img src={tabIcon1} />
//                 </div>
//                 <div className="">
//                   <div className="title">Create</div>
//                   <div className="dec text-muted fw-normal fs-14">New group or competition</div>
//                 </div>
//               </button>
//               <button type="button" onClick={() => navigate("/current-leaderboard")} className="btn textBtn screCardBtn border-0 text-start bg-transparent fw-medium text-dark d-flex align-items-center gap-12 position-relative">
//                 <div className="icon">
//                   <img src={tabIcon1} />
//                 </div>
//                 <div className="">
//                   <div className="title">Join</div>
//                   <div className="dec text-muted fw-normal fs-14">Track score while playing</div>
//                 </div>
//               </button>
//             </div>
//           </div>
//         </Modal.Body>
//       </Modal>

//       {/* How it work Modal  */}
//       <Modal show={show} size="lg" className="headerModals" onHide={scoreCardStepModalClose} centered>
//         <Modal.Header className="p-sm-4 p-3 position-relative justify-content-center" closeButton>
//           <Modal.Title>
//             <img src={logoVerticaleTheme} />
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body className="p-sm-4 p-3">
//           <div className="row g-3 align-items-center">
//             <div className="col-lg-4 col-md-6 text-center">
//               <img src={scoreCardModalImg} />
//             </div>
//             <div className="col-lg-8 col-md-6">
//               <div className="title fs-6 fw-medium">The Best way to Compete!</div>
//               <div className="dec fs-14 mt-1 text-muted">Live leader boards allow you to get real time updates of how your buddies are playing, even if hey are in a different foursome!</div>
//               <ul className="p-0 m-0 list-unstyled d-flex flex-column gap-sm-4 gap-3 mt-sm-4 mt-3">
//                 <li className="">
//                   <div className="d-flex align-items-center gap-1 fs-14 fw-medium"><img src={golfIcon} /> See Where You Stand:</div>
//                   <div className="fs-12 text-muted fw-medium">Click on the Ranking icon to see the leader board table and how you rank.</div>
//                 </li>
//                 <li className="">
//                   <div className="d-flex align-items-center gap-1 fs-14 fw-medium"><img src={golfIcon} />Track Foursome Score:</div>
//                   <div className="fs-12 text-muted fw-medium">Track up to 4 scores in your phone to feed the leader board.</div>
//                 </li>
//               </ul>
//               <div className="fs-14 fw-medium text-dark mt-4">NOTE: Make sure to complete your upload at the end to post scores.</div>
//             </div>
//           </div>
//         </Modal.Body>
//       </Modal>
//     </>

//   );
// }
// export default Play














